import { render } from "./DefInsertTildaSlider.vue?vue&type=template&id=8a276e8a&scoped=true"
import script from "./DefInsertTildaSlider.vue?vue&type=script&lang=js"
export * from "./DefInsertTildaSlider.vue?vue&type=script&lang=js"

import "./DefInsertTildaSlider.vue?vue&type=style&index=0&id=8a276e8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a276e8a"]])

export default __exports__